<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-left py-0 my-10">
        <h2 class="fs-1x fw-bolder mb-10">{{title}} de Restricción de Visita</h2>
         <div>
         <!-- <button @click="dataRefill">CARGAR</button> -->
         <div class="row">
         <!-- recinto penitenciario -->
         <div class="col-md-6 mt-3">
            <label class="form-label required">Recinto Penitenciario:</label>
              <select
                v-model="state.formData.id_recinto_penitenciario"
                class="form-select fuente"
                aria-label="select recinto penitenciario"
                :class="{
                  'is-invalid': v$.formData.id_recinto_penitenciario.$error,
                }"
                :disabled="rol==='visitas'"
              >
                <option
                  v-for="(list, key) in prisionNamesList"
                  :value="list.id_recinto_penitenciario"
                  :key="key"
                  :disabled="
                    list.nombre_recinto_penitenciario === 'TODOS' ||
                    (rol === 'visitas' &&
                      list.id_recinto_penitenciario !== id_recinto)
                  "
                >
                  {{ list.nombre_recinto_penitenciario }}
                </option>
              </select>
              <span
                class="text-danger"
                v-if="v$.formData.id_recinto_penitenciario.$error"
              >
                El registro del recinto penitenciario es requerido
              </span>
          </div>
          <!-- memoramdum restriccion -->
            <div class="col-md-6 mt-3">
              <label class="form-label required">Memorándum:</label>
              <input
                type="text"
                class="form-control fuente"
                :class="{
                  'is-invalid': v$.formData.memorandum_restriccion.$error,
                }"
                style="text-transform: uppercase"
                id="memorandum"
                v-model.trim="state.formData.memorandum_restriccion"
                v-uppercase
              />
              <span
                class="text-danger"
                v-if="v$.formData.memorandum_restriccion.$error"
              >
                El registro del memorandum es requerido
              </span>
            </div>
         </div>
            <!--búsqueda de visitante a ser retringido  v-if="state.formData.id_persona"-->
          <div>
            <div class="row">
              <div class="col-md-6 mt-5">
                <label class="form-label"
                  >Búsqueda Visita por N° de Documento de Identidad:
                  <i
                    class="fas fa-info-circle"
                    title="La búsqueda deberá realizarse por el Número de documento de identidad"
                  >
                  </i>
                </label>
                <input
                  type="text"
                  class="form-control fuente"
                  style="text-transform: uppercase"
                  id="dato_visita"
                  :disabled="!state.formData.id_recinto_penitenciario"
                  v-model.trim="dato_busqueda_visitante"
                  @keyup.enter="searchVisit(dato_busqueda_visitante, complemento_busqueda_visitante)"
                  @input="
                    checkFieldEmpty(
                      $event,
                      dato_busqueda_visitante,
                      'dato_visitante'
                    )
                  "
                />
              </div>
              <!-- complemento -->
              <div class="col-md-4 mt-5">
                <label class="form-label"
                  >Complemento:
                  <i
                    class="fas fa-info-circle"
                    title="El complemento son los dígitos alfanuméricos después del guión en la Cédula de Identidad (Por ejm. 12345678-1k)"
                  >
                  </i>
                </label>
                <input
                  type="text"
                  class="form-control fuente"
                  style="text-transform: uppercase"
                  id="dato_visita"
                  :disabled="!state.formData.id_recinto_penitenciario"
                  v-model.trim="complemento_busqueda_visitante"
                  @keyup.enter="searchVisit(dato_busqueda_visitante, complemento_busqueda_visitante)"
                />
              </div>
              <div class="col-md-2 col-sm-12 mt-7">
                <button
                  type="button"
                  style="margin: 5px"
                  class="btn px-3"
                  :disabled="!dato_busqueda_visitante"
                  @click="searchVisit(dato_busqueda_visitante, complemento_busqueda_visitante)"
                >
                  <i
                    title="Realizar búsqueda de visitante"
                    style="font-size: 1.5em; color: Dodgerblue"
                    class="fas fa-magnifying-glass"
                  >
                  </i>
                </button>
                <button
                  type="button"
                  style="margin: 10px"
                  class="btn px-3"
                  @click="
                    (dato_busqueda_visitante = ''),
                      (resultado_visitantes = []),
                      (state.formData.id_visita = ''),
                      v$.$reset()
                  "
                >
                  <i
                    title="Vaciar campo"
                    style="font-size: 1.5em; color: red"
                    class="fas fa-trash"
                  >
                  </i>
                </button>
              </div>
            </div>
            <!-- lista visitantes -->
             <div class="row">
                <table>
                  <caption v-if="resultado_visitantes.length > 0" style="caption-side: top">
                    {{
                      resultado_visitantes.length === 1 ? "Existe" : "Existen"
                    }}
                    {{
                      resultado_visitantes.length
                    }}
                    {{
                      resultado_visitantes.length === 1
                        ? "coincidencia"
                        : " posibles coincidencias"
                    }}
                  </caption>
                  <thead>
                    <tr>
                      <th>NOMBRE VISITANTE</th>
                      <th>N° DOCUMENTO</th>
                      <th>PAIS</th>
                      <th>RECINTO PENITENCIARIO</th>
                      <th>SELECCIONAR</th>
                    </tr>
                  </thead>
                  <tbody>
                    <td :style="{border:v$.formData.id_visita.$error?'2px solid red':''}" v-if="resultado_visitantes.length == 0 && !isLoading" colspan="8">
                      Sin datos que mostrar
                    </td>
                    <td v-else-if="resultado_visitantes.length == 0 && isLoading" colspan="8">
                      Cargando...
                    </td>
                    <tr v-else v-for="dato in resultado_visitantes" :key="dato.id_visita">
                      <td data-column="NOMBRE VISITANTE">{{ dato.nombre_completo }}</td>
                      <td data-column="N° DOCUMENTO">{{ dato.nro_doc }}</td>
                      <td data-column="PAIS">
                        {{ dato.pais }}
                      </td>
                      <td data-column="RECINTO">
                        {{ dato.nombre_recinto_penitenciario }}
                      </td>
                      <td data-column="SELECCIONAR">
                        <input
                          type="radio"
                          :value="dato.id_visita"
                          :id="dato.id_visita"
                          v-model="state.formData.id_visita"
                          @change="verificarRestriccion(state.formData.id_visita)"
                        />
                      </td>
                    </tr>
                  </tbody>
                  <span class="text-danger" v-if="v$.formData.id_visita.$error">
                    Seleccione un visitante
                  </span>
                </table>
              </div>
          </div>
          <!-- es por solicitud de ppl -->
          <div class="row mt-3">
            <div
              class="col-md-12 form-check form-check-custom form-check-solid mt-7 mb-7 m-4"
            >
              <input
                class="form-check-input h-30px w-30px"
                type="checkbox"
                id="isRequiredByPplCheckbox"
                v-model="isRequiredByPpl"
                @change="resetPpl"
              />
                  <label class="form-check-label" for="flexCheckbox40" style="font-size:15px">
                      Restricción por Solicitud de PPL
                      <i class="fas fa-info-circle"  title="Marque la casilla si la restricción es solicitada por un privado de libertad"></i>
                  </label>
            </div>
          </div>
          <!-- búsqueda ppl -->
          <div v-if="isRequiredByPpl">
          <!--búsqueda de persona privada de libertad que solicita restricción -->
            <div class="row">
              <div class="col-md-4 mt-5">
                <label class="form-label"
                  >Búsqueda PPL:
                  <i
                    class="fas fa-info-circle"
                    title="La búsqueda deberá realizarse por el Nombre completo o Número de documento de identidad"
                  >
                  </i>
                </label>
                <input
                  type="text"
                  class="form-control fuente"
                  style="text-transform: uppercase"
                  id="dato"
                  v-model="dato_busqueda_ppl"
                  @keyup.enter="searchPpl(dato_busqueda_ppl)"
                  @input="checkFieldEmpty($event, dato_busqueda_ppl, 'dato_ppl')"
                />
              </div>
              <div class="col-md-3 col-sm-12 mt-7">
                <button
                  type="button"
                  style="margin: 5px"
                  class="btn px-3"
                  :disabled="!dato_busqueda_ppl"
                  @click="searchPpl(dato_busqueda_ppl)"
                >
                  <i
                    title="Realizar búsqueda de Ppl"
                    style="font-size: 1.5em; color: Dodgerblue"
                    class="fas fa-magnifying-glass"
                  ></i>
                </button>
                <button
                  type="button"
                  style="margin: 10px"
                  class="btn px-3"
                  @click="
                    (dato_busqueda_ppl = ''),
                      (resultados_ppls = []),
                      (state.formData.id_persona = null),
                      v$.$reset()
                  "
                >
                  <i
                    title="Vaciar campo"
                    style="font-size: 1.5em; color: red"
                    class="fas fa-trash"
                  ></i>
                </button>
              </div>
            </div>
            <!-- lista de ppls -->
            <div  class="row">
              <table>
                <caption v-if="resultados_ppls.length > 0" style="caption-side: top">
                  {{
                    resultados_ppls.length === 1 ? "Existe" : "Existen"
                  }}
                  {{
                    resultados_ppls.length
                  }}
                  {{
                    resultados_ppls.length === 1
                      ? "coincidencia"
                      : " posibles coincidencias"
                  }}
                </caption>
                <thead>
                  <tr >
                    <th>NOMBRE PPL</th>
                    <th>N° DOCUMENTO</th>
                    <th>RECINTO PENITENCIARIO</th>
                    <th>DELITO</th>
                    <th>SELECCIONAR</th>
                  </tr>
                </thead>
                <tbody>
                  <td :style="{border:v$.formData.id_persona.$error?'2px solid red':''}" v-if="resultados_ppls.length == 0 && !isLoading" colspan="8">
                    Sin datos que mostrar
                  </td>
                  <td v-else-if="resultados_ppls.length == 0 && isLoading" colspan="8">
                    Cargando...
                  </td>
                  <tr v-else v-for="dato in resultados_ppls" :key="dato.id_persona">
                    <td data-column="NOMBRE PPL">{{ dato.nombre_completo }}</td>
                    <td data-column="N° DOCUMENTO">{{ dato.nro_doc }}</td>
                    <td data-column="RECINTO">
                      {{ dato.nombre_recinto_penitenciario }}
                    </td>
                    <td data-column="DELITO">{{ dato.descripcion_delito }}</td>
                    <td data-column="SELECCIONAR">
                      <input
                        type="radio"
                        :value="dato.id_persona"
                        :id="dato.id_persona"
                        v-model="state.formData.id_persona"
                      />
                    </td>
                  </tr>
                </tbody>
                <span class="text-danger" v-if="v$.formData.id_persona.$error">
                  Seleccione una Persona Privada de Libertad
                </span>
              </table>
            </div>
          </div>
          <!-- es indefinido -->
          <div class="row mt-3">
            <div
              class="col-md-12 form-check form-check-custom form-check-solid mt-7 mb-7 m-4"
            >
              <input
                class="form-check-input h-30px w-30px"
                type="checkbox"
                id="esIndefinidoCheckbox"
                v-model="state.formData.es_indefinido"
                @change="resetDates"
              />
                  <label class="form-check-label" for="flexCheckbox40" style="font-size:15px">
                      Restricción indefinida
                      <i class="fas fa-info-circle"  title="Marque la casilla si la restricción es indefinida"></i>
                  </label>
            </div>
          </div>
          <div class="row mt-3">
            <!-- norma legal -->
              <div class="col-md-6 mt-3">
                <label class="form-label required">Norma Legal infringida:</label>
                  <el-form>
                    <el-form-item>
                        <el-select
                          v-model="state.formData.normas_legales"
                          multiple
                          filterable
                          placeholder="Presione para seleccionar"
                          style="display:block"
                          :style="{border:v$.formData.normas_legales.$error?'1px solid red':''}"
                          >
                          <el-option
                            v-for="(list, key) in resultado_normativas"
                            :key="key"
                            :label="list.identificador_norma_legal"
                            :value="list.id_norma_legal"
                            >
                            <span style="float: left">{{ list.identificador_norma_legal }}</span>
                            <span
                              style="
                                float: right;
                                color: var(--el-text-color-secondary);
                                font-size: 10px;
                              "
                              >{{ list.descripcion_norma_legal }}</span
                            >
                          </el-option>
                        </el-select>
                        <span class="text-danger" v-if="v$.formData.normas_legales.$error">
                          Seleccione al menos una norma legal infringida
                        </span>
                    </el-form-item>
                  </el-form>
              </div>
              <!-- cantidad de días de restricción -->
              <div class="col-md-6 mt-3">
                <label class="form-label required">Cantidad días de restricción:<i class="fas fa-info-circle"  title="Debe ingresar solo números positivos"></i></label>
                <input
                  type="number"
                  class="form-control fuente"
                  :class="{ 'is-invalid': v$.formData.dias_restriccion.$error }"
                  style="text-transform: uppercase"
                  id="numero"
                  :disabled="state.formData.es_indefinido"
                  v-model.trim="state.formData.dias_restriccion"
                  v-uppercase
                  @input="validarNumero" 
                  @keydown="bloquearFlechas"
                  @change="setFinalRestiction"
                  pattern="[0-9]*" 
                  title="Ingrese solo números positivos"
                />
                <span class="text-danger" v-if="v$.formData.dias_restriccion.$error">
                  La cantidad de días de restricción es requerida
                </span>
              </div>
          </div>
          <div class="row mt-3">
              <!-- fecha de inicio -->
              <div class="col-md-6 mt-6">
                  <label class="form-label required">Fecha inicio de restricción:</label>
                    <input
                      type="date"
                      class="form-control fuente"
                      :class="{ 'is-invalid': v$.formData.fecha_inicio.$error }"
                      style="text-transform: uppercase"
                      id="fecha_inicio"
                      name="fecha_inicio"
                      :disabled="!state.formData.es_indefinido && !state.formData.dias_restriccion"
                      :max="currentDate"
                      v-model="state.formData.fecha_inicio"
                      @input="setFinalRestiction"
                      
                    />
                  <span class="text-danger" v-if="v$.formData.fecha_inicio.$error">
                    La fecha de inicio de la restricción es requerida
                  </span>
              </div>
              <!-- fecha final restriccion -->
              <div class="col-md-6 mt-6">
                  <label class="form-label required">Fecha finalización de restricción:</label>
                    <input
                      type="date"
                      class="form-control fuente"
                      style="text-transform: uppercase"
                      id="fecha_final"
                      name="fecha_final"
                      v-model="state.formData.fecha_final"
                      disabled
                    />
              </div>
          </div>
            <p class="m-10" align="right">
              <button
              v-if="!isLoading"
                class="btn btn-primary"
                @click="submitButton()"
              >
                {{button}}
              </button>
              <button
                v-else
                class="btn btn-primary"
                disabled
              >
                Por favor espere ...
              </button>
            </p>
         </div>
      </div>
      </div>
      </div>

    <!-- loader -->
    <loading
      v-model:active="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      :height="100"
      :width="100"
    ></loading>
  </template>
  
  <script>
  import {
    defineComponent,
    reactive,
    ref,
    onMounted,
    computed,
    watch,
  } from "vue";
  import useAuth from "@/auth/composables/useAuth";
  import filiation from "@/filiation/composables/useFiliation";
  import visits from "@/visits/composables/useVisits";
  import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
  import { useRouter } from "vue-router";
  import Swal from "sweetalert2/dist/sweetalert2.min.js";
  import Loading from "vue-loading-overlay";
  import date from "date-and-time";
  import "vue-loading-overlay/dist/vue-loading.css";
  import useVuelidate from "@vuelidate/core";
  import { required, requiredIf  } from "@vuelidate/validators";
  export default defineComponent({
    name: "register-restriction",
    components: {Loading},
    setup() {
      const router = useRouter();
      const title=ref("");
      const button=ref("");
      const isRequiredByPpl = ref(false);
      const isLoading = ref(false);
      const isDisabled = ref(false);
      const now = new Date();
      const pattern = date.compile("YYYY-MM-DD");
      const currentDate = date.format(now, pattern);
      const prisionNamesList = ref([]);
      const {
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
    } = useAuth();
      const {prisionNames} = filiation();
      const { valueToSearch, 
              valueToSearchVisit, 
              normativeList, 
              registerRestriction, 
              infoRestriction,
              updateRestriction,
              verifyRestriction,
              registerOnlyVisit
            } = visits();
      const dato_busqueda_ppl = ref("");
      const dato_busqueda_visitante = ref("");
      const complemento_busqueda_visitante = ref("");
      const resultados_ppls = ref([]);
      const resultado_visitantes = ref([]);
      const resultado_normativas = ref([]);
      const user = JSON.parse(localStorage.getItem("user"));
      const id_recinto_real = user.cod_recinto_penitenciario_real;
      const state = reactive({
        formData: {
            id_persona: null,
            id_visita: null,
            id_recinto_penitenciario: null,
            memorandum_restriccion:"",
            es_indefinido: false,
            normas_legales:[],
            dias_restriccion:"",
            fecha_inicio:"",
            fecha_final:"",
          },
        }
      );   
      const dataRefill = async() =>{
        state.formData.id_recinto_penitenciario='26',
        state.formData.memorandum_restriccion='ABC-123',
        state.formData.normas_legales=['1'],
        state.formData.dias_restriccion=60,
        state.formData.fecha_inicio='2023-12-05',
        await searchVisit('4323560','')


      };
      const listPrisionNames = async () => {
        const { data } = await prisionNames();
        if (rol.value === "visitas") {
          const filteredPrisionNames = data.filter(
            (item) =>
              item.id_recinto_penitenciario === id_recinto_real &&
              item.nombre_recinto_penitenciario !== "TODOS"
          );
          prisionNamesList.value = filteredPrisionNames;
          state.formData.id_recinto_penitenciario =
            filteredPrisionNames[0].id_recinto_penitenciario;
        } else if (rol.value === "supervisor") {
          const filteredPrisionNames = data.filter(
            (item) =>
              item.departamento === departamento_supervisar.value &&
              item.nombre_recinto_penitenciario !== "TODOS"
          );
          prisionNamesList.value = filteredPrisionNames;
        } else {
          const filteredPrisionNames = data.filter(
            (item) => item.nombre_recinto_penitenciario !== "TODOS"
          );
          prisionNamesList.value = filteredPrisionNames;
        }
      };   
      const resetPpl = () =>{
        state.formData.id_persona=null;
        dato_busqueda_ppl.value='';
        resultados_ppls.value=[]
      }
      const validarNumero = () => {
      // Eliminar caracteres no numéricos y asegurar que sea positivo
        state.formData.dias_restriccion = state.formData.dias_restriccion.replace(/[^0-9]/g, '');
          if (state.formData.dias_restriccion <= 0) {
            state.formData.dias_restriccion = '';
        }
      }
      const bloquearFlechas = (event) => {
    // Bloquear las teclas de flecha izquierda (37) y derecha (39)
    if (event.keyCode === 37 || event.keyCode === 39) {
      event.preventDefault();
    }
      }
      const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
      });
      const rules = computed(() => {
        return {
          formData: {
            id_persona:{
              required: requiredIf(() => isRequiredByPpl.value)
            },
            id_visita:{required},
            id_recinto_penitenciario: {required},
            memorandum_restriccion:{required},
            normas_legales:{
               required,
               minLength: value => value.length > 0
            },
            dias_restriccion:{
              required: requiredIf(() => !state.formData.es_indefinido)
            },
            fecha_inicio:{required},
          },
        };
    });
      const v$ = useVuelidate(rules, state);
      const getNormative = async () => {
      const { data } = await normativeList();
      resultado_normativas.value =data.respuesta;
      };
      // RESET 
      const resetData = () => {
        isDisabled.value = false;
        isRequiredByPpl.value=false;
        dato_busqueda_ppl.value='',
        dato_busqueda_visitante.value='',
        complemento_busqueda_visitante.value='',
        state.formData.id_persona= null;
        state.formData.id_visita= null;
        state.formData.id_recinto_penitenciario= null;
        state.formData.memorandum_restriccion="";
        state.formData.es_indefinido= false;
        state.formData.normas_legales=[];
        state.formData.dias_restriccion="";
        state.formData.fecha_inicio="";
        state.formData.fecha_final="";
        resultado_visitantes.value=[];  
        resultados_ppls.value = [];
        v$.value.$reset();
      };
      //buscar ppl para registrar restricción
      const searchPpl = async (value) => {
        isLoading.value = true;
        const { data } = await valueToSearch(value.toUpperCase());
        if (!data.ok) {
          Toast.fire({
            icon: "info",
            title: "No existen coincidencias con los datos ingresados",
          });
          isLoading.value = false;
        } else {
          if(router.currentRoute.value.params.id==='0'){
            Toast.fire({
              icon: "success",
              title: "La búsqueda retornó resultados!",
            });
          }
          isLoading.value = false;
          resultados_ppls.value = data.respuesta;
        }
      };
      //buscar visita para registrar restricción
      const searchVisit = async (numero_documento, complemento_documento) => {
        isLoading.value = true;
        const { data } = await valueToSearchVisit({numero_documento:numero_documento,complemento_documento:complemento_documento=='' ||complemento_documento==null || complemento_documento==undefined?complemento_documento:complemento_documento.toUpperCase()});
        if (!data.ok && data.segip) {
          Swal.fire({
              title: `¿Registrar visita?`,
              text: `La persona no se encuentra el la lista de visitantes,\n ¿Desea registrar a ${data.respuesta.Nombres} ${data.respuesta.PrimerApellido} ${data.respuesta.SegundoApellido} con N° de Documento ${data.respuesta.NumeroDocumento} como nueva visita? `,
              icon: "question",
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              showCancelButton: true,
              confirmButtonText: "Si, registrar",
              cancelButtonText: `No, cancelar`,
              reverseButtons: true
            }).then(async (result) => {
                if(result.isConfirmed){
                const resp = await registerOnlyVisit(data.respuesta)
                if(resp.data.ok){
                   await searchVisit(resp.data.nro_documento, resp.data.complemento)
                }else{
                  Swal.fire({
                    title: `ATENCIÓN`,
                    text: `Ocurrió un error, por favor intente nuevamente`,
                    icon: "error",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Aceptar"
                  })
                }
              }
            });
          isLoading.value = false;
        } else if(!data.ok && !data.segip){
          Swal.fire({
              title: `ATENCIÓN`,
              text: `${data.respuesta}`,
              icon: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar"
            })
          isLoading.value = false;
        }else if(data.ok) {
          if(router.currentRoute.value.params.id==='0'){
            Toast.fire({
            icon: "success",
            title: "La búsqueda retornó resultados!",
          });
          }
          isLoading.value = false;
          resultado_visitantes.value = data.respuesta;
        }
      };
      // verificar si campos de busqueda estan vacios
      const checkFieldEmpty = (dato, type) => {
        if (dato === "" && type === "dato_ppl") {
          state.formData.id_persona = null;
          resultados_ppls.value = [];
        } else if (dato === "" && type === "dato_visitante"){
          state.formData.id_visita = "";
          resultado_visitantes.value = [];
        }
      };
      // resetear formulario
      const resetDates = () =>{
        state.formData.fecha_inicio='',
        state.formData.fecha_final='',
        state.formData.dias_restriccion=''
      }
      // definir fecha final de la restriccion
      const setFinalRestiction = () =>{
         if (state.formData.fecha_inicio > currentDate) {
          Swal.fire({
                icon: "warning",
                title:"fecha de inicio de restricción errónea",
                text: `¡La fecha de inicio de la restricción no puede ser posterior a la fecha actual!`,
              });
        state.formData.fecha_inicio = '';
        state.formData.fecha_final = '';
      }
      if(!state.formData.es_indefinido && state.formData.fecha_inicio){
        const parsedDate = date.parse(state.formData.fecha_inicio, 'YYYY-MM-DD');
        const final_date = date.addDays(parsedDate, Number(state.formData.dias_restriccion));
        state.formData.fecha_final = date.format(final_date, pattern);
      }else{
        state.formData.fecha_final='';
      }
      }
      // enviar registro o edición
      const submitButton = async () => {
      const isFormCorrect = await v$.value.$validate();
      if (!isFormCorrect) return;
      try {
        isLoading.value=true
        if (router.currentRoute.value.params.id == "0") {
          const { data } = await registerRestriction(state.formData);
            if (data.ok) {
            isLoading.value=false
            Swal.fire({
              title: "¡Realizado!",
              text: `Registro de restricción realizado correctamente`,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
            // router.push({ name: "list_visits" });
            resetData();
           }else{
            Swal.fire({
              title: "¡Error!",
              text: `El registro de restricción no fue realizado `,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
           }
        }else{
          const { data } = await updateRestriction({id:router.currentRoute.value.params.id, form:state.formData})
            if (data.ok) {
            isLoading.value=false
            Swal.fire({
              title: "¡Realizado!",
              text: `${data.message}`,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
            // router.push({ name: "list_visits" });
            await getRestrictionInformation();
           }else{
            Swal.fire({
              title: "¡Error!",
              text: `La edición de la restricción no fue realizada `,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
           }
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
      };
      // obtener informacion de restricción
      const getRestrictionInformation = async () => {
        if(router.currentRoute.value.params.id==='0'){
          title.value = 'Registro';
          button.value = 'Registrar'
          return
        }else{
          title.value = 'Edición';
          button.value = 'Editar';
          const{data} = await infoRestriction(router.currentRoute.value.params.id)
          if(data.ok){
            await searchPpl(data.respuesta.nombre_ppl)
            await searchVisit(data.respuesta.nro_documento, data.respuesta.complemento)
            state.formData={...data.respuesta}
          }
        };

      }
      // verificar restricción
      const verificarRestriccion = async (id_visita) => {
       const { data } = await verifyRestriction({id_visita:id_visita, id_recinto:id_recinto.value})
       if (data.ok) {
        if (data.count_restriction>0) {
           Swal.fire({
              title: `Restricción Activa`,
              text: `${data.detail_restriction.nombre_completo} tiene una restricción activa.`,
              icon: "warning",
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Entendido"
            }).then(async (result) => {
                if(result.isConfirmed){
                state.formData.id_visita =''
              }
            });
        }
       }
      } 
  
      onMounted(() => {
        listPrisionNames();
        getNormative();
        getRestrictionInformation();
        setCurrentPageBreadcrumbs(`${title.value} de Restricción de Visitante`, ["Visitas"]);
      });
      watch(
        () => router.currentRoute.value.params.id,
        (newId, oldId) => {
          // Realiza acciones específicas antes de la actualización de la ruta
          if (newId !== oldId) {
            // Restablece los datos del formulario
            title.value = "Registrar";
            button.value = "Registrar"
            resetData();
          }
        }
      );
      return {
        dataRefill,
        rol,
        nombre_recinto_penitenciario,
        departamento_centro_penitenciario,
        departamento_supervisar,
        id_recinto,
        prisionNamesList,
        isRequiredByPpl,
        resetPpl,
        dato_busqueda_ppl,
        dato_busqueda_visitante,
        complemento_busqueda_visitante,
        resultados_ppls,
        resultado_visitantes,

        isDisabled,
        state,
        v$,
        isLoading,        
        searchPpl,
        searchVisit,
        currentDate,
        checkFieldEmpty,
        resetData,
        validarNumero,
        bloquearFlechas,
        resultado_normativas,
        setFinalRestiction,
        resetDates,
        submitButton,
        title,
        button,
        verificarRestriccion
      };
    },
    directives: {
      // transform input to uppercase with v-uppercase
      uppercase: {
        updated: function (el) {
          el.value = el.value.toUpperCase();
          el.dispatchEvent(new Event("input"));
        },
      },
    },
  });
  </script>
  
  <style scoped>
  :root {
    --color-text: #616161;
    --color-text-btn: #ffffff;
    --card1-gradient-color1: #f12711;
    --card1-gradient-color2: #f5af19;
    --card2-gradient-color1: #7f00ff;
    --card2-gradient-color2: #e100ff;
    --card3-gradient-color1: #3f2b96;
    --card3-gradient-color2: #a8c0ff;
    --card4-gradient-color1: #11998e;
    --card4-gradient-color2: #38ef7d;
  }
  .fuente {
    font-size: 0.97em;
    padding: 0.35em;
    font-weight: normal;
  }
  .card-wrap {
    background: #fff;
    border-radius: 20px;
    border: 3px solid rgb(221, 221, 221);
    overflow: hidden;
    color: var(--color-text);
    /* box-shadow: rgb(87, 174, 255) 10px 10px 10px,
      rgba(199, 192, 192, 0.23) 0px 1px 1px; */
    cursor: auto;
    transition: all 0.2s ease-in-out;
    padding: 10px;
  }
  p.round3 {
    border: 1px solid;
    border-radius: 5px;
    border-left-width: 7px;
    border-left-color: #037915;
    padding: 10px;
  }
  p.round4 {
    border: 1px solid;
    border-radius: 5px;
    border-left-width: 7px;
    border-left-color: #ff0000;
    padding: 10px;
  }
  table {
    width: auto;
    border-collapse: collapse;
    margin: 20px auto;
  }
  
  /* Zebra striping */
  tr:nth-of-type(odd) {
    background: #eee;
  }
  
  th {
    background: #3498db;
    color: white;
    font-weight: bold;
  }
  
  td,
  th {
    padding: 10px;
    border: 1px solid #ccc;
    text-align: center;
    font-size: 12px;
  }
  /* 
  Max width before this PARTICULAR table gets nasty
  This query will take effect for any screen smaller than 760px
  and also iPads specifically.
  */
  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    table {
      width: 100%;
    }
  
    /* Force table to not be like tables anymore */
    table,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }
  
    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }
  
    tr {
      border: 1px solid #ccc;
    }
  
    td {
      /* Behave  like a "row" */
      border: none;
      border-bottom: 1px solid #eee;
      position: relative;
      padding-left: 50%;
    }
  
    td:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 6px;
      left: 6px;
      width: 45%;
      padding-right: 10px;
      white-space: nowrap;
      /* Label the data */
      content: attr(data-column);
  
      color: #000;
      font-weight: bold;
    }
  }
  </style>
  